<template>
	<div class="code_login">
		<van-popup v-model="login_popup_show" @click-close-icon="closeClick" round close-on-popstate closeable
			:close-on-click-overlay="false">
			<div class="code_login_pop">
				<div class="title">登&nbsp;&nbsp;录</div>
				<input type="number" placeholder="请输入手机号" maxlength="11" class="input cell_item color_a font_size_a"
					v-model="loginAccount" />
					
				<!--短信验证码方式-->
				<transition name="van-slide-right">
					<div v-if="loginType == 2">
						<drag-verify v-if="loginAccount.trim().length==11" :width="vwToPx(60)" :height="vwToPx(10)" :text="text"
							:success-text="successText" :background="background" :progress-bar-bg="progressBarBg"
							:completed-bg="completedBg" :handler-bg="handlerBg" :handler-icon="handlerIcon" :text-size="vwToPx(4)+'px'"
							:success-icon="successIcon" :circle="isCircle" @passcallback="passcallback"></drag-verify>

						<div class="flex_c cell_item" >
							<input type="number" placeholder="请输入验证码" class="input code_input color_a font_size_a" v-model="loginCode" />
							<div v-show="!hasStartCountDown" class="color_b font_size_e code_btn"
								:style="{ 'opacity': (loginAccount.trim().length==11&&verifySuccess?'1':'0.6')}" @click="startCountDown">
								获取验证码
							</div>
							<van-count-down v-show="hasStartCountDown" ref="countDown" :auto-start="false" class="code_btn"
								style="opacity: 0.6;" :time="countDownTime" format="ss s" @finish="finishCountDown" />
						</div>

						<div class="login_btn font_size_a color_b"
							:style="{ 'opacity': (loginAccount.trim().length==11&&loginCode&&verifySuccess?'1':'0.6')}" @click="toLogin">
							登录</div>
						<div @click="changLoginType(1)" style="font-size: 14px;color: #089ce7;text-align: right; margin-top: 10px;">账号密码登录</div>	
					</div>
				</transition>
				
				<!--密码方式登录-->
				<transition name="van-slide-right">
					<div v-if="loginType == 1">
						<input type="password" placeholder="请输入密码" maxlength="20" class="input cell_item color_a font_size_a"
							v-model="loginPassword" />
						<div class="login_btn">
							<div class="login_btn font_size_a color_b" @click="loginByAccountAndPassword">登录</div>
						</div>
						<div style="font-size: 14px;color: #089ce7;text-align: right; margin-top: 10px;" @click="changLoginType(2)">短信验证登录</div>
					</div>
				</transition>
				
			</div>
		</van-popup>
	</div>
</template>

<script>
	import api from '@/apis/api'
	import dragVerify from 'vue-drag-verify'
	import tool from "@/common/tool";
	import {
		mapGetters,
		mapMutations
	} from 'vuex';

	export default {

		name: "",
		data() {
			return {
				//短信验证码方式登录参数
				hasStartCountDown: false, //是否显示倒计时
				loginAccount: "",
				loginCode: "",
				verifySuccess: false, //滑块是否滑完
				countDownTime: 60 * 1000, //60秒倒计时
				// 滑块组件配置
				handlerIcon: "van-icon van-icon-arrow",
				successIcon: "van-icon van-icon-passed",
				background: "#d0d0d0",
				progressBarBg: "#1E9FFF",
				completedBg: "#1E9FFF",
				handlerBg: "#fff",
				text: "请拖动滑块验证",
				successText: "验证通过",
				isCircle: false,
				
				//账号密码方式登录参数
				loginType: 2, //默认短信验证方式登入
				loginPassword: "",
			};
		},
		props: {},
		components: {
			dragVerify
		},
		created() {},
		computed: {
			...mapGetters('userModule', ['getToken']),

			login_popup_show: {
				get() {
					return this.$store.state.userModule.login_popup_show
				},
				set(v) {}
			},
		},
		watch: {
			// 监听当弹窗状态为打开时,初始化弹窗中的一些变量
			'$store.state.userModule.login_popup_show'(newVal) {
				if (newVal) {
					this.hasStartCountDown = false
					this.verifySuccess = false
					this.loginAccount = ''
					this.loginCode = ''
				}
			}
		},
		mounted() {},
		methods: {
			...mapMutations('userModule', ['SET_TOKEN', 'SET_MOBILE']),

			closeClick() {
				this.$store.commit('userModule/SET_login_popup_show', false)
			},
			// 滑动组件支持单位是px,适配计算
			vwToPx(vw) {
				return (window.innerWidth / 100) * vw;
			},
			// 滑块滑完验证
			passcallback() {
				this.verifySuccess = true
			},

			// 点击获取验证码短信按钮
			startCountDown() {
				if (!this.loginAccount.trim()) {
					this.$toast("请输入手机号码");
					return false
				}
				if (this.loginAccount.trim().length != 11) {
					this.$toast("请输入完整的手机号");
					return false
				}
				if (!this.verifySuccess) {
					this.$toast("请拖动滑块验证");
					return false
				}

				// 获取验证码
				api
					.get(`/p/user/getLoginSmsCode/${this.loginAccount}`)
					.then((res) => {
						if (res.success) {
							this.$refs.countDown.reset();
							this.hasStartCountDown = true
							this.$refs.countDown.start();
						} else {
							this.$toast(res.message);
						}
					});
			},

			// 验证码倒计时结束,显示获取短信按钮
			finishCountDown() {
				this.hasStartCountDown = false
			},

			// 点击登录按钮
			toLogin() {
				if (!this.loginAccount.trim()) {
					this.$toast("请输入手机号码");
					return false
				}
				if (this.loginAccount.trim().length != 11) {
					this.$toast("请输入完整的手机号");
					return false
				}
				if (!this.loginCode.trim()) {
					this.$toast("请输入验证码");
					return false
				}
				if (!this.verifySuccess) {
					this.$toast("请拖动滑块验证");
					return false
				}

				// 先判断账号是否注册，注册了的走登录接口，没注册的弹提示是否要直接注册登录
				this.$toast.loading({
					overlay: true,
					forbidClick: true,
					duration: 0
				})
				api
					.get(`/p/user/phoneIsRegistered/${this.loginAccount}`)
					.then((res) => {
						if (res.success) {
							if (res.data) { //true已注册(直接登录) false未注册（弹窗询问是否需要直接登录）
								this.confirmLogin()
							} else {
								this.$toast.clear()
								this.$dialog.confirm({
									title: '提示',
									message: '该手机号还未注册过，是否直接用该手机号注册并登录'
								}).then(() => {
									this.confirmLogin()
								}).catch(() => {})
							}
						} else {
							this.$toast.clear()
							this.$toast(res.message);
						}
					});
			},

			// 登录接口
			confirmLogin() {
				api.post('/login', {
					loginAccount: this.loginAccount,
					loginType: 2, //1账号密码 2验证码
					loginCode: this.loginCode,
				}).then(r => {
					this.$toast.clear()
					if (r.success) {
						//console.log(r)

						//清空并重置所有信息
						localStorage.clear()
						localStorage.removeItem('questionMode');
						localStorage.removeItem('questionNumber');
						sessionStorage.clear()

						this.SET_TOKEN(r.data.token)
						this.SET_MOBILE(this.loginAccount)

						// 关闭弹窗
						this.$store.commit('userModule/SET_login_popup_show', false)

						// 调用自定义更新数据事件
						this.$emit('update-page');
					} else {
						this.$toast(r.data)
					}
				})
			},
			// 账号密码方式登录接口
			loginByAccountAndPassword() {
				if (!this.loginAccount.trim()) {
					this.$toast("请输入手机号码");
					return false
				}
				if (this.loginAccount.trim().length != 11) {
					this.$toast("请输入完整的手机号");
					return false
				}
				
				// 先判断账号是否注册，注册了的走登录接口，没注册的弹提示是否要直接注册登录
				this.$toast.loading({
					overlay: true,
					forbidClick: true,
					duration: 0
				})
				api.post('/login', {
					loginAccount: this.loginAccount,
					loginType: 1, //1账号密码 2验证码
					loginPassword: this.loginPassword,
				}).then(r => {
					this.$toast.clear()
					if (r.success) {
						console.log(r)
			
						//清空并重置所有信息
						localStorage.clear()
						localStorage.removeItem('questionMode');
						localStorage.removeItem('questionNumber');
						sessionStorage.clear()
			
						this.SET_TOKEN(r.data.token)
						this.SET_MOBILE(this.loginAccount)
			
						// 关闭弹窗
						this.$store.commit('userModule/SET_login_popup_show', false)
			
						// 调用自定义更新数据事件
						this.$emit('update-page');
					} else {
						this.$toast(r.data)
					}
				})
			},
			
			changLoginType(type){
				this.loginAccount = ""
				this.loginType = type
			},
		},
	};
</script>

<style scoped>
	/* 防止滑动滑块的时候触发部分机型的浏览器右滑手势返回上一页 */
	*	{
		/* 属性将取消浏css览器的X轴Y轴默认行为，这个阻止了左右翻页的默认行为的同时，也阻止了上下滑动的行为，
		显然我们不希望它阻止Y轴的上下翻滚，ontouch移动端事件不在阻止范围 
		它的作用是禁用元素的默认触摸行为，使得元素不会对触摸事件做出响应。*/
	 touch-action:none;
	 /*此属性将赋予给Y轴的上下滚动行为
	 是另一个CSS属性，它的作用是允许元素在垂直方向上进行滚动操作，而禁用其他触摸行为。*/
	 touch-action:pan-y;
	}
	/* 滑块组件开始 */
	>>>.dv_handler {
		height: calc(10vw - 2px) !important;
		display: flex;
		justify-content: center;
		align-items: center;
		top: 50% !important;
		transform: translateY(-50%);
	}

	>>>.dv_handler.dv_handler_ok_bg {
		border-color: #1E9FFF !important;
		left:unset !important;
		right: 0 !important;
	}

	>>>.drag_verify .van-icon {
		font-size: 5vw !important;
	}

	>>>.drag_verify .van-icon-passed {
		color: #1E9FFF !important;
	}
	/* 滑块组件结束 */
</style>
<style lang="scss" scoped>
	.code_login_pop {
		padding: 30px 40px;
	}

	.code_login_pop .title {
		font-size: 20px;
		text-align: center;
		color: #000;
	}

	.code_login_pop .input {
		padding: 0;
		border: none;
		border-bottom: 1px solid #bbb;
		outline: none;
		height: 10vw;
		line-height: 10vw;
		font-size: 15px;
		border-radius: unset !important;
	}

	.code_login_pop .cell_item {
		width: 60vw;
		margin: 20px 0;
	}

	.code_login_pop .code_input {
		width: 30vw;
	}

	.code_login_pop .code_btn {
		width: 23vw;
		background-color: #1E9FFF;
		height: 10vw;
		line-height: 10vw !important;
		text-align: center;
		border-radius: 5px;
	}

	.code_login_pop .van-count-down {
		color: #fff !important;
		font-size: 13px !important;
	}

	.code_login_pop .login_btn {
		width: 60vw;
		height: 10vw;
		line-height: 10vw;
		text-align: center;
		background-color: #1E9FFF;
		border-radius: 5px;
	}

	::v-deep .van-popup__close-icon {
		position: absolute !important;
		font-size: 24px !important;
	}
</style>